<style>
.cardx {
	margin : 15px
}

table td:last-child, th:last-child {
    text-align: right !important;
    padding: 15px !important;
}

table td{
	padding: 6px 10px !important;
	padding-top: 5px !important;
	padding-bottom: 3px !important;
}
  
</style>

<template>
<div>
	<vs-row>
		<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
		</vs-col>
	  <vs-col vs-type="flex" vs-justify="right" vs-align="right" vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
	  	<vs-card class="cardx">
	  		<flat-pickr v-model="date" :config="datepicker_option"  class="w-full" @on-close="doSomethingOnChange" />
	  	</vs-card>
		</vs-col>
	</vs-row>
  <vs-row>
	  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
	  	<vs-card class="cardx">
	      <div slot="header">
	        <h4>
	          Total Sales
	        </h4>
	      </div>
	      <div>
	        <apexchart type="line" :options="tsoptions" :series="tsseries"></apexchart>
	      </div>
	    </vs-card>
	  </vs-col>

	  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
	  	<vs-card class="cardx">
	      <div slot="header">
	        <h4>
	          Total Order
	        </h4>
	      </div>
	      <div>
	        <apexchart type="line" :options="tooptions" :series="toseries"></apexchart>
	      </div>
	    </vs-card>
	  </vs-col>
	</vs-row>

	<vs-row>
		<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
		  <vs-card class="cardx">
	      <div slot="header">
	        <h4>
	          Cumulative Sales
	        </h4>
	      </div>
	      <div>
	        <apexchart type="line" :options="csoptions" :series="csseries"></apexchart>
	      </div>
	    </vs-card>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
	    <vs-card class="cardx">
	      <div slot="header">
	        <h4>
	          Cumulative Orders
	        </h4>
	      </div>
	      <div>
	        <apexchart type="line" :options="cooptions" :series="coseries"></apexchart>
	      </div>
	    </vs-card>
    </vs-col>
	</vs-row>

	<vs-row>
		<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
		  <vs-card class="cardx">
	      <div slot="header">
	        <h4>
	          Sales by product
	        </h4>
	      </div>
	      <div>
	        <vs-table stripe style="width:100%;" :data="sales_product">
	        	<thead>
	        		<tr><th>#</th> <th>Product</th> <th>Total sales</th></tr>
	        	</thead>
	        	<tbody>
	        		<vs-tr :data="tr" :key="tr.variant_id" v-for="(tr, indextr) in sales_product">
	        			<vs-td>
		              <p class="product-name font-medium truncate">{{ indextr+1 }}</p>
		            </vs-td>
		            <vs-td>
		              <p class="product-name font-medium truncate">{{ tr.name }}</p>
		            </vs-td>
		            <vs-td>
		              <p class="product-name font-medium truncate">{{ tr.data }}</p>
		            </vs-td>
		          </vs-tr>
	        	</tbody>
	        </vs-table>
	      </div>
	    </vs-card>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
		  <vs-card class="cardx">
	      <div slot="header">
	        <h4>
	          Products units sold
	        </h4>
	      </div>
	      <div>
	        <vs-table stripe style="width:100%;" :data="product_unit">
	        	<thead>
	        		<tr><th>#</th> <th>Product</th> <th>Units sold</th></tr>
	        	</thead>
	        	<tbody>
	        		<vs-tr :data="tr" :key="tr.variant_id" v-for="(tr, indextr) in product_unit">
	        			<vs-td>
		              <p class="product-name font-medium truncate">{{ indextr+1 }}</p>
		            </vs-td>
		            <vs-td>
		              <p class="product-name font-medium truncate">{{ tr.name }}</p>
		            </vs-td>
		            <vs-td>
		              <p class="product-name font-medium truncate">{{ tr.data }}</p>
		            </vs-td>
		          </vs-tr>
	        	</tbody>
	        </vs-table>
	      </div>
	    </vs-card>
   	</vs-col>
	</vs-row>

	<!-- <vs-row>
		<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-lg="6" vs-sm="12" vs-xs="12">
	    <vs-card class="cardx">
	      <div slot="header">
	        <h4>
	          Sales by customer
	        </h4>
	      </div>
	      <div>
	        <vs-table stripe style="width:100%;" :data="sales_customer">
	        	<thead>
	        		<tr><th>#</th> <th>Customer</th> <th>Contact</th> <th>Total sales</th></tr>
	        	</thead>
	        	<tbody>
	        		<vs-tr :data="tr" :key="tr.variant_id" v-for="(tr, indextr) in sales_customer">
	        			<vs-td>
		              <p class="product-name font-medium truncate">{{ indextr+1 }}</p>
		            </vs-td>
		            <vs-td>
		              <p class="product-name font-medium truncate">{{ tr.name }}</p>
		            </vs-td>
		            <vs-td>
		              <p class="product-name font-medium truncate">CONTACT</p>
		            </vs-td>
		            <vs-td>
		              <p class="product-name font-medium truncate">{{ tr.data }}</p>
		            </vs-td>
		          </vs-tr>
	        	</tbody>
	        </vs-table>
	      </div>
	    </vs-card>
  	</vs-col>
	</vs-row> -->

</div>
</template>

<script>
	import flatPickr from 'vue-flatpickr-component'
	import 'flatpickr/dist/flatpickr.css'
	import axios from '@/axios';
  export default {
  	components: {
	    flatPickr
	  },
    data() {
    	// adding limit to datepicker
			let previousYear = new Date();
			previousYear.setYear(previousYear.getFullYear()-1);
      return {
      	daterange : [this.formatDate(new Date().fp_incr(-14)),this.formatDate(new Date())],
      	date : null,
      	datepicker_option : {mode: 'range',dateFormat: 'Y-m-d',defaultDate: [new Date().fp_incr(-14),new Date()],minDate: previousYear.getFullYear()+"-"+previousYear.getMonth()+1,maxDate: new Date()},
	      tsoptions: {},
	      tsseries: [],
	      tooptions: {},
	      toseries: [],
	      csoptions: {},
	      csseries: [],
	      cooptions: {},
	      coseries: [],
	      sales_product: [],
      	sales_customer: [],
      	product_unit: []
	    }
    },
    async created() {
    	await this.loadGraph();
    },
    methods:{
    	async loadGraph(){
    		this.$vs.loading()
	    	let yoption = {
			    labels: {
			      formatter: function(val, index) {
			        return val.toFixed(0);
			      }
			    }
			  };
	      let result = await axios.post('/report/'+this.$store.state.user.current_organization,{daterange:this.daterange});
	      let ts = result.data.data.total_sale;
	      let to = result.data.data.total_order;
	      let cs = result.data.data.cumulative_sale;
	      let co = result.data.data.cumulative_order;
	      this.sales_product = result.data.data.sales_product.rank;
	      this.sales_customer = result.data.data.sales_customer.rank;
	      this.product_unit = result.data.data.product_unit.rank;
	     	this.tsseries = ts.series;
	      this.tsoptions = {chart: {id: 'vuechart-ts'},xaxis: ts.xaxis};

	      this.toseries = to.series;
	      let toyaxis = Object.assign({}, yoption);
	    	if(to.series[0].data.some(el => el > 2)){
				}else{
					toyaxis.tickAmount = 1;
				}
	      this.tooptions = {chart: {id: 'vuechart-to'},xaxis: to.xaxis, yaxis: toyaxis};

	      this.csseries = cs.series;
	      this.csoptions = {chart: {id: 'vuechart-cs'},xaxis: cs.xaxis};

	      this.coseries = co.series;
	      let coyaxis = Object.assign({}, yoption);
	    	if(to.series[0].data.some(el => el > 2)){
				}else{
					coyaxis.tickAmount = 1;
				}
	      this.cooptions = {chart: {id: 'vuechart-co'},xaxis: co.xaxis, yaxis: coyaxis};
	      this.$vs.loading.close();
    	},
    	formatDate(date) {
		    var d = new Date(date),
	        month = '' + (d.getMonth() + 1),
	        day = '' + d.getDate(),
	        year = d.getFullYear();
		    if (month.length < 2) 
		        month = '0' + month;
		    if (day.length < 2) 
		        day = '0' + day;
		    return [year, month, day].join('-');
			},
    	doSomethingOnChange(selectedDates){
    		this.daterange = [];
    		for(let a of selectedDates){
    			this.daterange.push(this.formatDate(a))
    		}
    		// call to reload it 
    		this.loadGraph();
    	}
    }
  }
</script>